export type ConnectionSettingResponse = {
  id: string;
  name: string | null;
  clientId: string | null;
  schemeId: string | null;
  companyId: string;
  companyName: string | null;
  updatedByName: string | null;
  createdDate: string;
  updatedDate: string | null;
  allowedToEdit: boolean;
};

export type ConnectionSettingDetailsResponse = ConnectionSettingResponse & {
  clientSecret: string | null;
};

export type CreateConnectionSettingModel = {
  name: string;
  companyId: string;
  schemeId?: string;
};

export type DataGatewayCompanyResponse = {
  id: string;
  name: string;
};

export type DataGatewaySchemeResponse = {
  id: string;
  name: string;
  companyId: string;
};

export type CreateIpRecordModel = {
  ip: string;
  description?: string;
};

export type UpdateIpRecordModel = CreateIpRecordModel & {
  id: string;
};

export type ConnectionIpWhiteListResponse = {
  id: string;
  ip: string;
  description: string | null;
  createdDate: string;
  updatedDate: string | null;
};

export type UpdateConnectionPermissionModel = {
  read: boolean;
  write: boolean;
};

export type ModuleResponse = UpdateConnectionPermissionModel & {
  id: string;
  name: string;
  logoUrl: string;
};

export type ModulePermissionModel = UpdateConnectionPermissionModel & {
  moduleId: string;
};

export type ConnectionPermissionResponse = UpdateConnectionPermissionModel & {
  id: string;
  moduleId: string;
  connectionSettingId: string;
  createdDate: string;
  updatedDate: string;
};

export type ThirdPartyPlatformSettingSearchResponse = {
  id: string;
  name: string | null;
  createdDate: string;
  updatedById: string;
  updatedByName: string | null;
  updatedDate: string | null;
  companyName: string | null;
  appName?: ThirdPartyPlatformSettingApp;
};

export type ThirdPartyPlatformSettingSearchResponsePagedResponse = {
  totalCount: number;
  items: ThirdPartyPlatformSettingSearchResponse[] | null;
};

export type CompanyDto = {
  id: string;
  isDefault?: boolean;
  schemeId?: string;
};

export enum ThirdPartyPlatformSettingApp {
  PenScope = 'PenScope',
  LumeraCore = 'LumeraCore',
  Untangler = 'Untangler',
}
export enum AuthType {
  Basic = 'Basic',
  Bearer = 'Bearer',
  Untangler = 'Untangler',
}

export type CreateThirdPartyPlatformSettingDto = {
  name: string;
  appName: ThirdPartyPlatformSettingApp;
  authType: AuthType;
  authUrl?: string;
  apiUrl: string;
  clientId: string;
  clientSecret: string;
  company: CompanyDto;
};

export type UpdateThirdPartyPlatformSettingDto = Omit<CreateThirdPartyPlatformSettingDto, 'company'>;

export type ThirdPartyPlatformCompanyResponse = {
  id: string;
  name: string;
  hasDefaultSetting: boolean;
  schemes: DataGatewaySchemeResponse[] | null;
};

export type ThirdPartyPlatformSettingResponse = {
  id: string;
  name: string | null;
  appName: ThirdPartyPlatformSettingApp;
  authType: AuthType;
  authUrl: string | null;
  apiUrl: string | null;
  clientId: string | null;
  clientSecret: string | null;
  createdDate: string;
  updatedById: string;
  updatedByName: string | null;
  updatedDate: string | null;
  isDefault: boolean;
  company: DataGatewayCompanyResponse;
  scheme: DataGatewaySchemeResponse | null;
};

export enum TrafficHttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export enum TrafficResultGroup {
  Success = 'Success',
  Refused = 'Refused',
  ClientError = 'ClientError',
  ServerError = 'ServerError',
  Unknown = 'Unknown',
  Test = 'Test',
}

export enum TrafficResponseOrigin {
  Unknown = 'Unknown',
  Gateway = 'Gateway',
  Downstream = 'Downstream',
}

export type TrafficAuditItemResponse = {
  id: string;
  startedAt: string;
  productId: string | null;
  product: string | null;
  companyId: string | null;
  companyName: string | null;
  clientId: string | null;
  httpMethod: string | null;
  requestPath: string | null;
  requestSizeBytes: number | null;
  responseStatus: number | null;
  durationMs: number;
  resultGroup: TrafficResultGroup;
  responseOrigin: TrafficResponseOrigin;
  downstreamStatus: number | null;
};

export type TrafficAuditItemResponsePagedResponse = {
  totalCount: number;
  items: TrafficAuditItemResponse[] | null;
};

export type TrafficAuditSummaryResponse = {
  generatedAtUtc: string;
  fromUtc: string;
  toUtc: string;
  totalRequests: number;
  successRequests: number;
  failedOrRefusedRequests: number;
  unknownRequests: number;
  successRatePercent: number | null;
  testRequests: number;
  products: TrafficAuditProductResponse[] | null;
};

export type TrafficAuditProductResponse = {
  id: string;
  name: string | null;
};
